export class GalleryModal {
  constructor(userOptions) {
    this.options = { ...GalleryModal.DefaultOptions, ...userOptions };
    this.visible = false;
    this.$contents = $('<div class="col"></div>');
    this.$bodyContainer = $('<div class="modal-body">')
      .append($('<div class="container-fluid">')
        .append($('<div class="row">')
          .append(this.$contents)));

    this.$modal = $('<div class="modal fade" tabindex="-1">')
      .append($(`<div class="modal-dialog modal-${this.options.modalSize}">`)
        .append($('<div class="modal-content">')
          .append($('<div class="modal-header">')
            .append($('<div class="bnt-close-wrapper"></div>')
              .append($('<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close">'))))
          .append(this.$bodyContainer)));

    if (this.options.modalClass) {
      this.$modal.addClass(this.options.modalClass);
    }

    this.$modal.on('hidden.bs.modal', () => {
      this.visible = false;
      let destination = '#';
      if (window.location.hash.includes('/')) {
        const pathParts = window.location.hash.split('/');
        destination = pathParts.splice(0, pathParts.length - 1).join('/');
      }

      if (window.history.pushState) {
        window.history.pushState(null, null, destination);
      } else {
        window.location.hash = destination;
      }
    });

    this.$modal.on('shown.bs.modal', () => {
      this.visible = true;
    });
  }

  setContent(content) {
    this.$contents.html(content);
  }

  show() {
    if (!this.visible) {
      this.$modal.modal('show');
    } else {
      this.$modal.modal('handleUpdate');
    }
  }

  hide() {
    this.$modal.modal('hide');
  }
}

GalleryModal.DefaultOptions = {
  modalSize: 'lg',
  modalClass: null,
};

export function setupGalleryRouting(routingTable, contentRenderCallback, options) {
  const modal = new GalleryModal(options);

  function update() {
    const item = routingTable[window.location.hash];
    if (item !== undefined) {
      modal.setContent(contentRenderCallback(item));
      modal.show();
    } else {
      modal.hide();
    }
  }

  const onHashChange = () => {
    update();
  };

  $(window).on('hashchange', onHashChange);
  update();

  return () => {
    $(window).off('hashchange', onHashChange);
  };
}

function renderGalleryItem(item) {
  return $('<a class="idm-gallery-item"></a>')
    .attr('href', item.route)
    .append(
      $('<img class="img-fluid">')
        .attr('alt', '')
        .attr('src', item.thumbnail)
    )
    .on('click', (ev) => {
      ev.preventDefault();
      // Navigate via location.replace to create a better history
      // when navigating back after opening several items
      window.location.replace(item.route);
      return false;
    });
}

function renderGallery(items, options) {
  const list = $('<div class="idm-gallery"></div>');
  const row = $('<div class="row"></div>')
    .appendTo(list);
  row.append(
    items.map((item) => $('<div class="col-xl-2 col-lg-3 col-md-4 col-6"></div>').append(
      renderGalleryItem(item, options)
    ))
  );
  return list;
}

export default function createGallery(container, items, renderDetailCallback, options) {
  const removeRouting = setupGalleryRouting(Object.fromEntries(
    items.map((each) => [each.route, each])
  ), renderDetailCallback, options);

  $(container).empty().append(renderGallery(items, options));

  return () => {
    $(container).empty();
    removeRouting();
  };
}
